import { Button } from "@progress/kendo-react-buttons";

export default function EmptyState({
  actionLabel,
  description,
  icon = "empty",
  onAction,
  title
}) {
  const isKendoIcon = typeof icon === "string" && icon.startsWith("k-i-");

  return (
    <div className="empty-state">
      <div className="empty-state-illustration" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <div className="empty-state-icon" aria-hidden="true">
        {isKendoIcon ? <span className={`k-icon ${icon}`} /> : icon}
      </div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {actionLabel && onAction && (
        <Button themeColor="primary" icon="plus" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
